import { NoteVisibilityEnum, NoteType } from "@/features/Notes/Note";
import PlatformDocumentMetadata from "@/features/PlatformDocuments/PlatformDocumentMetadata";
import UploadedPlatformDocumentMetadata from "@/features/PlatformDocuments/UploadedPlatformDocumentMetadata";

export default class NoteRequestModel {
    userID: string = "";
    userName: string = "";
    noteText: string = "";
    visibilityLevel: NoteVisibilityEnum = null!;
    noteType: NoteType = null!;
    visibleSupplierID: string = "";
    visibleSupplierName: string = "";
    supplierEventID: string = "";
    uploadedPlatformDocumentMetadatas: UploadedPlatformDocumentMetadata[] = [];
    platformDocumentMetadataIDs: string[] = [];
    platformDocumentMetadatas: PlatformDocumentMetadata[] = [];
}
